<template>
    <div class="default-page">
        <div class="buttons">
            <button class="button btn-primary"
                    v-if="getPermissionSection('create')"
                    @click="goToCreate">
                {{ $ml.get('buttons.create') }}
            </button>

            <button :class="['button', button.class]" :key="index"
                    v-for="(button, index) in buttons"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <TableFilter
            v-if="getPermissionSection('view_search')"
            @resetFilter="resetFilter"
            @applyFilter="applyFilter"
            :filter="filter"
            :filter-open="filterOpen"/>

        <div class="block" v-if="getPermissionSection('view_list')">
            <div class="title">{{ dashboardTitle }}</div>
            <div class="body">
                <Table :paginate-count="paginateCount"
                       :page="page"
                       :last_page="last_page"
                       @setPage="setPage">
                    <template slot="thead">
                        <Thead :header="tableHeader" :is-counter="tableHeaderChange" @sortBy="sortBy" />
                    </template>
                    <template slot="tbody">
                        <tr v-for="item in listItems" :key="item.id">
                            <td>
                                <a class="link"
                                   v-if="getPermissionSection('edit')"
                                   :href="getLinkEdit(item.id)">
                                    {{ item.id }}
                                </a>
                                <span v-else>{{ item.id }}</span>
                            </td>
                            <td v-for="(col, index) in tableHeader"
                                v-if="col.key !== 'id'"
                                :key="index"
                                :class="[{'text-left': col.key === 'title'}, col.classes ? col.classes : '']">

                                <template v-if="tableBody[col.key]">
                                    <template v-if="tableBody[col.key].type === 'string'">
                                        {{ item[col.key] }}
                                    </template>
                                    <template v-if="tableBody[col.key].type === 'boolean'">
                                        {{ getBooleanValue(item[col.key]) }}
                                    </template>
                                    <template v-if="tableBody[col.key].type === 'dictionary'">
                                        {{ getDictionaryValue(tableBody[col.key], item) }}
                                    </template>
                                    <template v-if="tableBody[col.key].type === 'concat'">
                                        {{ getConcatValue(tableBody[col.key], item) }}
                                    </template>
                                    <template v-if="tableBody[col.key].type === 'function'">
                                        <div v-html="tableBody[col.key].function(item)"></div>
                                    </template>
                                </template>
                                <template v-else-if="col.key === 'activated'">
                                    <select class="select"
                                            @change="saveItem(item)"
                                            v-model="item.activated">
                                        <option v-for="item in filtersDefault.activated.options"
                                                :value="item.id">
                                            {{ item.title }}
                                        </option>
                                    </select>
                                </template>
                                <template v-else-if="col.key === 'buttons'">
                                    <a class="button btn-primary"
                                       v-if="getPermissionSection('edit')"
                                       :title="$ml.get('interface.edit')"
                                       :href="getLinkEdit(item.id)">
                                        <span class="icon ico-i icon-edit"></span>
                                    </a>
                                    <button class="button btn-danger"
                                            v-if="getPermissionSection('delete')"
                                            :title="$ml.get('interface.delete')"
                                            @click="openDeleteWindow(item)">
                                        <span class="icon ico-i icon-delete"></span>
                                    </button>
                                </template>
                                <template v-else>
                                    {{ item[col.key] }}
                                </template>
                            </td>
                        </tr>
                    </template>
                </Table>
            </div>
        </div>

        <div class="block ">
            <div class="title">Generate codes</div>

            <div class="body flex-row-wrap" @keyup.enter="generateCodes">
                <div class="w33" v-for="(item, key) in generateForm">
                    <div class="formBlock">
                        <p class="label">{{ item.label }}</p>
                        <input type="number" class="input"
                               v-if="item.type==='number'"
                               :placeholder="item.label"
                               v-model="generateForm[key].value">
                        <input type="text" class="input"
                               v-if="item.type==='text'"
                               :placeholder="item.label"
                               v-model="generateForm[key].value">
<!--                        <select v-model="generateForm[key].value" class="select"-->
<!--                                v-else-if="item.type==='select'">-->
<!--                            <option :value="null">Not selected</option>-->
<!--                            <option v-for="(option, id) in item.options" :value="option.id">-->
<!--                                {{ option[item.title ? item.title : 'title'] }}-->
<!--                            </option>-->
<!--                        </select>-->
                        <div class="defaultMultiselect" v-else-if="item.type==='select'">
                            <Multiselect
                                track-by="id"
                                :label="item.title ? item.title : 'title'"
                                v-model="generateForm[key].value"
                                :options="item.options"
                                :placeholder="item.label">
                                <template v-slot="noResult">
                                    {{ $ml.get('interface.no_result') }}
                                </template>
                                <template v-slot="noOptions">
                                    {{ $ml.get('interface.no_options') }}
                                </template>
                            </Multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <button class="button" @click="generateCodes">
                    Generate
                </button>
            </div>
        </div>

        <div class="block ">
            <div class="title">Report codes</div>
            <div class="body flex-row-wrap" @keyup.enter="generateReportCodes">
                <div class="w33" v-for="(item, key) in generateReportForm">
                    <div class="formBlock">
                        <p class="label">{{ item.label }}</p>
                        <date-picker v-if="item.type==='date'"
                            valueType="format"
                            format="MM/DD/YYYY"
                            v-model="generateReportForm[key].value"
                            :placeholder="item.label"
                        />
                        <input type="number" class="input"
                               v-if="item.type==='number'"
                               :placeholder="item.label"
                               v-model="generateReportForm[key].value">
                        <input type="text" class="input"
                               v-if="item.type==='text'"
                               :placeholder="item.label"
                               v-model="generateReportForm[key].value">
                        <select v-model="generateReportForm[key].value" class="select"
                                v-else-if="item.type==='select'">
                            <option :value="null">Not selected</option>
                            <option v-for="(option, id) in item.options" :value="option.id">
                                {{ item.title ? option[item.title] : option.title }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="footer">
                <button class="button" @click="generateReportCodes">
                    Generate
                </button>
            </div>
        </div>

        <ModalWindow :open="openConfirmDelete"
                     @closeModal="openConfirmDelete = false">
            <template slot="title">
                {{ $ml.get('interface.confirm_action') }}
            </template>
            <template slot="body">
                {{ $ml.get('interface.confirm_action_delete') }}
            </template>
            <template slot="buttons">
                <button class="button btn-danger" @click="deleteItem">
                    {{ $ml.get('buttons.delete') }}
                </button>
            </template>
        </ModalWindow>

    </div>
</template>

<script>
import ListDefault from "../../Utils/Page/ListDefault";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import dayjs from "dayjs";

export default {
    name: "List",
    components: {DatePicker, Multiselect},
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.partner_promo_code'),

            generateReportForm: {
                partner_id: { label: 'Partner', value: null, type: 'select', options: [] },
                plan_id: { label: 'Membership', value: null, type: 'select', options: [] },
                type: { label: 'Type', value: null, type: 'select', options: [] },
                activated_from: { label: 'Activated from', value: null, type: 'date' },
                activated_to:  { label: 'Activated until', value: null, type: 'date' },
                company_id:  { label: 'Company', value: null, type: 'select', options: [], title: 'company_name' },
            },
            generateForm: {
                partner_id: { label: 'Partner', value: null, type: 'text', options: [] },
                promo_owner_id: { label: 'Owner', value: null, type: 'select', options: [], title: 'name' },
                plan_id: { label: 'Membership', value: null, type: 'select', options: [] },
                type: { label: 'Type', value: null, type: 'select', options: [] },
                count: { label: 'Count', value: 10, type: 'number' },
                company_id: { label: 'Company', value: null, type: 'select', options: [], title: 'company_name' },
            },

            filter: {
                code: { value: null, type: 'text'},
                partner: { value: null, type: 'text'},
                promo_owner: { value: null, type: 'text'},
                company_id: { value: null, type: 'text'},
            },

            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'code', is_sort: true, classes: 'text-l' },
                { key: 'partner', is_sort: true, classes: 'text-l' },
                { key: 'promo_owner', is_sort: true, classes: 'text-l' },
                { key: 'plan', is_sort: true, classes: 'text-l' },
                { key: 'type', is_sort: true, classes: 'text-l' },
                { key: 'user', is_sort: true, classes: 'text-l' },
                { key: 'activated', is_sort: true, classes: 'text-l' },
                { key: 'company_id', is_sort: true, classes: 'text-l' },
                //{ key: 'activated_at', is_sort: true, classes: 'text-l' },
                //{ key: 'created_at', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {

                activated: {
                    type: 'function',
                    function: this.getActivated
                },
                type: {
                    type: 'function',
                    function: this.getTypeName
                },
                plan: {
                    type: 'function',
                    function: this.getPlanName
                },
                user: {
                    type: 'function',
                    function: this.getUserName
                },
                promo_owner: {
                    type: 'function',
                    function: this.getOwnerName
                },
                company_id: {
                    type: 'function',
                    function: this.getCompanyName
                },
            },

            apiList: this.$store.getters.getApiUrl('marketing.partner_promo_code'),
            pageRoute: 'partner_promo_code',
            pageRouteCreate: 'partner_promo_code.create',
            pageRouteEdit: 'partner_promo_code.edit',
            pagePermission: 'marketing.partner_promo_code',
        }
    },
    mounted() {
        this.getDictionaries().then(({data}) => {
            this.generateForm.type.options = data.dictionaries.type
            this.generateForm.partner_id.options = data.dictionaries.partner
            this.generateForm.plan_id.options = data.dictionaries.plan_id
            this.generateForm.promo_owner_id.options = data.dictionaries.user_id
            this.generateForm.company_id.options = data.dictionaries.company_id

            this.generateReportForm.type.options = data.dictionaries.type
            this.generateReportForm.partner_id.options = data.dictionaries.partner
            this.generateReportForm.plan_id.options = data.dictionaries.plan_id
            this.generateReportForm.company_id.options = data.dictionaries.company_id
        })
    },
    methods: {
        generateReportCodes() {
            let data = {
                type: this.generateReportForm.type.value,
                partner_id: this.generateReportForm.partner_id.value,
                plan_id: this.generateReportForm.plan_id.value,
                activated_from: this.generateReportForm.activated_from.value,
                activated_to: this.generateReportForm.activated_to.value,
                company_id: this.generateReportForm.company_id.value,
            }
            axios.post(this.$store.getters.getApiUrl('marketing.partner_promo_code.generate_report_list'), data, { responseType: 'blob' }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Report activated affiliate codes.xlsx');
                document.body.appendChild(link);
                link.click();
            })
        },
        generateCodes() {
            let data = {
                type: this.generateForm.type.value?.id ?? null,
                partner_id: this.generateForm.partner_id.value,
                plan_id: this.generateForm.plan_id.value?.id ?? null,
                count: this.generateForm.count.value,
                promo_owner_id: this.generateForm.promo_owner_id.value?.id ?? null,
                company_id: this.generateForm.company_id.value?.id ?? null,
            }
            axios.post(this.$store.getters.getApiUrl('marketing.partner_promo_code.generate_list'), data, { responseType: 'blob' }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Generated codes.xlsx');
                document.body.appendChild(link);
                link.click();

                this.getData()
            })
        },
        getActivated(item) {
            if (!item.activated) return '-'

            return `${ dayjs(item.activated_at).format('MM/DD/YYYY HH:mm:ss')}`
        },
        getUserName(item) {
            if (!item.user) return '-'

            return `@${item.user.name}`
        },
        getOwnerName(item) {
            if (!item.owner) return '-'

            return `@${item.owner.name}`
        },
        getPlanName(item) {
            if (!item.plan) return '-'

            return `${item.plan.title}`
        },
        getTypeName(item) {
            if (!item.type) return '-'

            return `${item.type_title}`
        },
        getCompanyName(item) {
            if (!item.company) return '-'

            return `${item.company.company_name}`
        },
    }
}
</script>

<style scoped>

</style>
